import { render, staticRenderFns } from "./DataTableLaskuliite.vue?vue&type=template&id=5312a259&scoped=true&"
import script from "./DataTableLaskuliite.vue?vue&type=script&lang=js&"
export * from "./DataTableLaskuliite.vue?vue&type=script&lang=js&"
import style0 from "./DataTableLaskuliite.vue?vue&type=style&index=0&id=5312a259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5312a259",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5312a259')) {
      api.createRecord('5312a259', component.options)
    } else {
      api.reload('5312a259', component.options)
    }
    module.hot.accept("./DataTableLaskuliite.vue?vue&type=template&id=5312a259&scoped=true&", function () {
      api.rerender('5312a259', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataTableLaskuliite.vue"
export default component.exports